import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { OVERVIEW_PAGE_CONTENT } from "../../Dashboard/constants"
import { getAssetPath } from "../../../utils/assets"

const StyledNav = styled.nav`
  img:first-child {
    width: 64px;
    margin-right: 1em;
  }
  img:last-child {
    display: none;
    @media (min-width: 768px) {
      display: inline-block;
    }
  }
`

function Header({ form, onSaveHandler }) {
  return (
    <div className="fixed-top">
      <StyledNav className="navbar navbar-light bg-white">
        <div>
          <Link to="/overview">
            <img src={getAssetPath("icn-back")} style={{ width: "30px" }} />
            <img style={{ width: "0px" }} />
          </Link>
          <Link to="/matchfit-dashboard">
            <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.matchfit.logoAssetName)} width={64} height={64} />
            <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.matchfit.textAssetName)} width={240} height={36} />
          </Link>
        </div>
        {onSaveHandler && <button className="btn btn-outline-main btn-sm" type="button" onClick={onSaveHandler}>Save Draft</button>}
      </StyledNav>
      <div className="progress survey-progress">
        <div
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={0}
          aria-label="MatchFit survey completion"
          style={{ width: `${(Object.keys(form || {}).length / 48) * 100}%` }}
          className="progress-bar"
          role="progressbar" />
      </div>
    </div>
  )
}

export default Header